module.exports = __webpack_public_path__ + "static/media/BlueLeftArrow.6671ca11.svg";